import { render, staticRenderFns } from "./productPriceHistory.vue?vue&type=template&id=298302b7&"
import script from "./productPriceHistory.vue?vue&type=script&lang=js&"
export * from "./productPriceHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports